// extracted by mini-css-extract-plugin
export default {"card":"yla-z"};